const dialCodes = [
  { code: '+48', countryPL: 'Polska', flag: '🇵🇱' },
  { code: '+49', countryPL: 'Niemcy', flag: '🇩🇪' },
  { code: '+33', countryPL: 'Francja', flag: '🇫🇷' },
  { code: '+39', countryPL: 'Włochy', flag: '🇮🇹' },
  { code: '+34', countryPL: 'Hiszpania', flag: '🇪🇸' },
  { code: '+44', countryPL: 'Wielka Brytania', flag: '🇬🇧' },
  { code: '+43', countryPL: 'Austria', flag: '🇦🇹' },
  { code: '+420', countryPL: 'Czechy', flag: '🇨🇿' },
  { code: '+421', countryPL: 'Słowacja', flag: '🇸🇰' },
  { code: '+36', countryPL: 'Węgry', flag: '🇭🇺' },
  { code: '+40', countryPL: 'Rumunia', flag: '🇷🇴' },
  { code: '+380', countryPL: 'Ukraina', flag: '🇺🇦' },
  { code: '+7', countryPL: 'Rosja', flag: '🇷🇺' },
  { code: '+46', countryPL: 'Szwecja', flag: '🇸🇪' },
  { code: '+47', countryPL: 'Norwegia', flag: '🇳🇴' },
  { code: '+358', countryPL: 'Finlandia', flag: '🇫🇮' },
  { code: '+31', countryPL: 'Holandia', flag: '🇳🇱' },
  { code: '+32', countryPL: 'Belgia', flag: '🇧🇪' },
  { code: '+351', countryPL: 'Portugalia', flag: '🇵🇹' },
  { code: '+386', countryPL: 'Słowenia', flag: '🇸🇮' },
  { code: '+385', countryPL: 'Chorwacja', flag: '🇭🇷' },
  { code: '+357', countryPL: 'Cypr', flag: '🇨🇾' },
  { code: '+90', countryPL: 'Turcja', flag: '🇹🇷' },
  { code: '+1', countryPL: 'Stany Zjednoczone', flag: '🇺🇸' },
  { code: '+55', countryPL: 'Brazylia', flag: '🇧🇷' },
  { code: '+86', countryPL: 'Chiny', flag: '🇨🇳' },
  { code: '+91', countryPL: 'Indie', flag: '🇮🇳' },
  { code: '+81', countryPL: 'Japonia', flag: '🇯🇵' },
  { code: '+61', countryPL: 'Australia', flag: '🇦🇺' },
  { code: '+1', countryPL: 'Kanada', flag: '🇨🇦' },
  { code: '+62', countryPL: 'Indonezja', flag: '🇮🇩' },
  { code: '+82', countryPL: 'Korea Południowa', flag: '🇰🇷' },
  { code: '+63', countryPL: 'Filipiny', flag: '🇵🇭' },
];

class KlaviyoForm extends HTMLElement {
  constructor() {
    super();
  }
}
class KlaviyoNewsletterForm extends HTMLElement {
  e164Regex = /^\+[1-9]\d{1,14}$/;
  constructor() {
    super();
    this.firstStepList = 'Ydmh33';
    this.secondStepList = 'Vwt9iq';

    this.firstStep = {
      endpoint: '/tools/custom/sign-to-customer',
      title: `Wskocz do newslettera i odbierz do 23% zniżki!`,
      description: `Dołącz do newslettera po regularną porcję wspaniałości i odbierz do 23% zniżki!<br>Minimalna wartość zamówienia to 80 zł.`,
    };
    this.secondStep = {
      endpoint: '/tools/custom/sign-to-customer',
      title: `Dzięki za zapis! A co powiesz na <i>jeszcze wiekszą</i> zniżkę?`,
      description: `Zostaw swój numer telefonu, a najbliższe zakupy zrobisz taniej nawet o 28%!`,
    };

    this.finalTitle = 'Super, że jesteś!';
    this.finalDescription =
      'Wspaniale mieć Cie w gronie naszych newsletterowiczek_ów! Juz niedługo wpadniemy do Ciebie z pierwszą porcją wspaniałości!';
    this.buttonLabel = 'odbieram zniżkę';
    this.placement = 'custom-form-footer';
    this.root = null;
    this.email = '';
  }

  connectedCallback(root) {
    this.root = root || this.querySelector('#klaviyo-root');
    this._setupHeaderElements();

    this.renderEmailStep();
  }

  _setupHeaderElements() {
    this.titleElement = this.parentNode.querySelector('#newsletterTitle');
    this.descriptionElement = this.parentNode.querySelector('#newsletterDescription');
  }

  renderEmailStep() {
    this._insertEmailHeader(this.firstStep);
    this._injectEmailForm();

    this._attachEmailHandlers();
  }

  _insertEmailHeader(step) {
    if (!this.titleElement || !this.descriptionElement) return;
    this.titleElement.innerHTML = '';
    this.titleElement.insertAdjacentHTML('afterbegin', step.title);
    this.descriptionElement.innerHTML = '';
    this.descriptionElement.insertAdjacentHTML('afterbegin', step.description);
  }

  _injectEmailForm() {
    this.root.innerHTML = /* HTML */ `
      <form class="klaviyo-email-form flex flex-col gap-2 w-fit">
        <div class="flex flex-col tab:flex-row w-full gap-2">
          <input
            type="text"
            name="email"
            placeholder="Twój e-mail"
            class="w-full px-4 py-2 border border-gray20 rounded-sm shadow-sm focus:ring focus:ring-pink-100 focus:border-pink-400 transition"
          />
          <button
            type="submit"
            class="bg-white text-text-black01 border-text-black01 hover:bg-text-black01 hover:text-white hover:border-white border border-solid px-5 rounded-sm font-semibold py-2 transition uppercase font-sans text-xs shrink-0 mt-0 tracking-[2px]"
          >
            ${this.buttonLabel}
          </button>
        </div>

        <p class="klaviyo-email-msg text-sm max-w-[500px]"></p>

        <label class="text-sm flex gap-2 items-baseline text-bg-white">
          <input
            type="checkbox"
            name="consent"
            class="font-sans text-xs font-medium leading-[1.45] tracking-[0.26px]"
          />
          <span class="max-w-[600px]">
            Chcę zapisać się do Newslettera (informacje o promocjach, zniżkach, premierach, konkursach oraz artykułach z
            serwisu You KNOW)
          </span>
        </label>
        <p class="klaviyo-email-consent-msg text-sm max-w-[500px] text-tomato"></p>
      </form>
    `;
  }

  _attachEmailHandlers() {
    this.querySelector('.klaviyo-email-form').addEventListener('submit', async (e) => {
      e.preventDefault();

      const form = e.target;
      const email = form.email.value.trim();
      const button = form.querySelector('button');
      const consent = form.querySelector('[name="consent"]');

      this.displayFormError('email-consent', '');
      this.displayFormError('email', '');

      if (!email) {
        this.displayFormError('email', 'Adres e-mail jest wymagany.');
        return;
      }

      if (!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
        this.displayFormError('email', 'Wprowadź poprawny adres e-mail.');
        return;
      }

      if (consent && !consent.checked) {
        this.displayFormError('email-consent', 'Musisz zaakceptować regulamin.');
        return;
      }

      button.disabled = true;
      button.textContent = 'Wysyłanie...';

      try {
        const res = await fetch(this.firstStep.endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...(location.origin.includes('127.0.0.1') && {
              Origin: location.origin,
            }),
          },
          body: JSON.stringify({ email, source: this.placement }),
        });

        const data = await res.json();

        if (res.ok && data.ok) {
          this.email = email;
          this.renderSMStep();
        } else {
          const error = JSON.parse(data.error);
          this.displayFormError(
            'email',
            'Błąd: ' + (Array.isArray(error?.errors) ? error.errors[0]?.detail : 'Spróbuj ponownie.')
          );
          console.warn('Błąd zapisu:', error);
        }
      } catch (err) {
        this.displayFormError('email', 'Wystąpił błąd sieci. Spróbuj ponownie.');
        console.error('Błąd sieci:', err);
      } finally {
        button.disabled = false;
        button.textContent = 'Zapisz się';
      }
    });
  }

  renderSMStep() {
    this._insertSmsHeader(this.secondStep);
    this._injectSmsForm();
    this._attachSmsHandlers();
  }

  _insertSmsHeader(step) {
    if (!this.titleElement || !this.descriptionElement) return;
    this.titleElement.innerHTML = '';
    this.titleElement.insertAdjacentHTML('afterbegin', step.title);
    this.descriptionElement.innerHTML = '';
    this.descriptionElement.insertAdjacentHTML('afterbegin', step.description);
  }

  _injectSmsForm() {
    this.root.innerHTML = /* HTML */ `
      <form class="klaviyo-sms-form flex flex-col gap-2" novalidate>
        <div class="flex flex-col tab:flex-row w-full gap-2">
          <div class="flex w-full gap-2">
            <select name="prefix" class="border border-gray-300 rounded-sm border-gray20 px-3 py-2">
              ${dialCodes
                .map(
                  ({ code, flag }) =>
                    `<option value="${code}" ${code === '+48' ? 'selected' : ''}>${flag} ${code}</option>`
                )
                .join('')}
            </select>
            <input
              type="tel"
              name="phone"
              pattern="[0-9]{6,14}"
              placeholder="123 456 789"
              class="w-full px-4 py-2 border border-gray20 rounded-sm shadow-sm focus:ring focus:ring-pink-100 focus:border-pink-400 transition"
            />
          </div>
          <button
            type="submit"
            class="bg-white text-text-black01 border-text-black01 hover:bg-text-black01 hover:text-white hover:border-white border border-solid px-5 rounded-sm font-semibold py-2 transition uppercase font-sans text-xs shrink-0 mt-0 tracking-[2px]"
          >
            ${this.buttonLabel}
          </button>
        </div>

        <p class="klaviyo-sms-msg text-sm"></p>

        <label class="text-sm flex gap-2 items-baseline text-bg-white">
          <input
            type="checkbox"
            name="consent"
            class="font-sans text-xs font-medium leading-[1.45] tracking-[0.26px]"
          />
          <span class="max-w-[600px]">
            Chcę otrzymywać wiadomości SMS/MMS (informacje o promocjach, zniżkach, premierach i konkursach oraz
            artykułach z serwisu You KNOW)
          </span>
        </label>
        <p class="klaviyo-sms-consent-msg text-sm"></p>
      </form>
    `;
  }

  _attachSmsHandlers() {
    this.querySelector('.klaviyo-sms-form').addEventListener('submit', async (e) => {
      e.preventDefault();

      const form = e.target;
      const prefix = form.prefix.value.replace(/\s+/g, '');
      const number = form.phone.value.replace(/\s+/g, '');
      const full = prefix + number;

      const button = form.querySelector('button');
      const consent = form.consent.checked;

      this.displayFormError('sms-consent', '');
      this.displayFormError('sms', '');

      if (!number) {
        this.displayFormError('sms', 'Numer telefonu jest wymagany.');
        return;
      }

      if (!this.e164Regex.test(full)) {
        this.displayFormError('sms', 'Wprowadź poprawny numer telefonu.');
        return;
      }

      if (!consent) {
        this.displayFormError('sms-consent', 'Musisz zaakceptować regulamin.');
        return;
      }

      button.disabled = true;
      button.textContent = 'Wysyłanie...';

      const res = await fetch(this.secondStep.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          phone: full,
          email: this.email,
          source: this.placement,
        }),
      });

      const data = await res.json();

      if (!data.ok) {
        const error = JSON.parse(data.error);
        button.disabled = false;
        button.textContent = this.buttonLabel;
        return this.displayFormError(
          'sms',
          'Błąd: ' + (Array.isArray(error?.errors) ? error.errors[0]?.detail : 'Spróbuj ponownie.')
        );
      }

      this.renderThanks();
    });
  }

  renderThanks() {
    this._insertThanksHeader();
    this._insertThanksBody();
    this._attachThanksHandlers();
  }

  _insertThanksHeader() {
    if (!this.titleElement) return;
    this.titleElement.innerHTML = this.finalTitle;
    this.titleElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  _insertThanksBody() {
    if (this.descriptionElement) {
      this.descriptionElement.innerHTML = this.finalDescription;
    }
  }

  _attachThanksHandlers() {
    this.remove();
  }

  displayFormError(type, content) {
    const msg = this.root.querySelector(`.klaviyo-${type}-msg`);

    if (content) {
      msg.textContent = content;
      msg.classList.add('text-tomato');
    } else {
      msg.textContent = '';
    }
  }
}

window.customElements.define('klaviyo-form', KlaviyoNewsletterForm);

class KlaviyoFloatingForm extends KlaviyoNewsletterForm {
  constructor() {
    super();
    this.placement = 'custom-form-sticky';

    this.first = {
      image: this.getAttribute('data-image-first'),
      text: this.getAttribute('data-text-first'),
    };

    this.second = {
      image: this.getAttribute('data-image-second'),
      text: this.getAttribute('data-text-second'),
    };

    this.final = {
      text: this.getAttribute('data-text-final'),
    };
  }

  connectedCallback() {
    this.root = this.querySelector('#klaviyo-root');
    super.connectedCallback();
  }

  _setupHeaderElements() {}

  _injectEmailForm() {
    this.root.innerHTML = /* HTML */ `
      <div class="flex flex-col max-w-[450px] p-5 bg-[#f6f6f6]">
        <div class="max-w-full">
          <img class="object-cover" src="${this.first.image}" />
        </div>
        <form class="klaviyo-email-form flex flex-col gap-2 w-fit mt-2">
          <div class="flex flex-col w-full gap-2">
            <input
              type="text"
              name="email"
              placeholder="Twój e-mail"
              class="text-xs w-full h-[40px] px-4 py-2 border border-gray20 rounded-sm shadow-sm focus:ring focus:ring-pink-100 focus:border-pink-400 transition"
            />
            <button
              type="submit"
              class="btn btn--primary-2 border border-solid px-5 rounded-sm font-semibold py-2 transition uppercase font-sans text-xs shrink-0 tracking-[2px]"
            >
              ${this.buttonLabel}
            </button>
          </div>

          <p class="klaviyo-email-msg text-sm max-w-[500px]"></p>

          <p class="text-sm">${this.first.text}</p>

          <label class="text-sm flex gap-2 items-baseline text-black cursor-pointer">
            <input
              type="checkbox"
              name="consent"
              class="font-sans text-xs font-medium leading-[1.45] tracking-[0.26px]"
            />
            <span class="max-w-[600px]">
              Chcę zapisać się do Newslettera (informacje o promocjach, zniżkach, premierach, konkursach oraz artykułach
              z serwisu You KNOW)
            </span>
          </label>
          <p class="klaviyo-email-consent-msg text-sm max-w-[500px] text-tomato"></p>
        </form>

        <div class="flex w-full justify-center gap-1">
          <a class="text-xs underline" href="https://yourkaya.pl/policies/terms-of-service">Regulamin zakupów</a>
          <span class="text-xs">i</span>
          <a class="text-xs underline" href="https://yourkaya.pl/policies/privacy-policy">Polityka prywatności</a>
        </div>
      </div>
    `;
  }

  _injectSmsForm() {
    this.root.innerHTML = /* HTML */ `
      <div class="flex flex-col max-w-[450px] p-5 bg-[#f6f6f6">
        <div class="max-w-full mb-2">
          <img class="object-cover" src="${this.second.image}" />
        </div>
        <form class="klaviyo-sms-form flex flex-col gap-2" novalidate>
          <div class="flex flex-col w-full gap-2 mt-2">
            <div class="flex w-full gap-2">
              <select name="prefix" class="border border-gray-300 rounded-sm border-gray20 py-2 text-xs">
                ${dialCodes
                  .map(
                    ({ code, flag }) =>
                      `<option value="${code}" ${code === '+48' ? 'selected' : ''}>${flag} ${code}</option>`
                  )
                  .join('')}
              </select>
              <input
                type="tel"
                name="phone"
                pattern="[0-9]{6,14}"
                placeholder="123 456 789"
                class="text-xs w-full h-[40px] px-4 py-2 border border-gray20 rounded-sm shadow-sm focus:ring focus:ring-pink-100 focus:border-pink-400 transition"
              />
            </div>
            <button
              type="submit"
              class="btn btn--primary-2 border border-solid px-5 rounded-sm font-semibold py-2 transition uppercase font-sans text-xs shrink-0 tracking-[2px]"
            >
              ${this.buttonLabel}
            </button>
          </div>

          <p class="klaviyo-sms-msg text-sm"></p>

          <p class="text-sm">${this.second.text}</p>

          <label class="text-sm flex gap-2 items-baseline">
            <input
              type="checkbox"
              name="consent"
              class="font-sans text-xs font-medium leading-[1.45] tracking-[0.26px]"
            />
            <span class="text-xs max-w-[600px]">
              Chcę otrzymywać wiadomości SMS/MMS (informacje o promocjach, zniżkach, premierach i konkursach oraz
              artykułach z serwisu You KNOW)
            </span>
          </label>
          <p class="klaviyo-sms-consent-msg text-sm"></p>
        </form>

        <div class="flex w-full justify-center gap-1">
          <a class="text-xs underline" href="https://yourkaya.pl/policies/terms-of-service">Regulamin zakupów</a>
          <span class="text-xs">i</span>
          <a class="text-xs underline" href="https://yourkaya.pl/policies/privacy-policy">Polityka prywatności</a>
        </div>
      </div>
    `;
  }

  _insertEmailHeader(step) {}

  _insertSmsHeader(step) {}

  renderThanks() {
    this.root.innerHTML = `
      <div class="floating-thanks flex items-center flex-col gap-2 p-5 text-center rounded-t-md text-[22px] font-normal">
        ${this.final.text}
        <button class="back-to-shop mt-5 btn btn--primary-2 w-fit border border-solid px-5 rounded-sm font-semibold py-2 transition uppercase font-sans text-xs shrink-0 tracking-[2px]">Wróć do sklepu</button>
      </div>
    `;
    const btn = this.root.querySelector('.back-to-shop');
    const stickyModal = document.getElementById('newsletter-sticky-modal');
    const popupModal = document.querySelector('.popup-newsletter');
    if (btn) {
      btn.addEventListener('click', () => {
        if (this.placement === 'custom-form-sticky') {
          if (stickyModal) stickyModal.classList.remove('active');
        } else if (this.placement === 'custom-form-popup') {
          if (popupModal) popupModal.classList.remove('active');
        }
      });
    }
  }
}

customElements.define('klaviyo-floating-form', KlaviyoFloatingForm);

class KlaviyoPopupForm extends KlaviyoFloatingForm {
  constructor() {
    super();
    this.placement = 'custom-form-popup';
  }
}
customElements.define('klaviyo-popup-form', KlaviyoPopupForm);

class KlaviyoMetaobjectForm extends KlaviyoNewsletterForm {
  constructor() {
    super();
    this.data = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
    this.placement = this.data.placement;
    if (this.data.first.list) this.firstStepList = this.data.first.list;
    if (this.data.second.list) this.secondStepList = this.data.second.list;
  }

  connectedCallback() {
    const root = document.createElement('div');
    this.appendChild(root);
    super.connectedCallback(root);
    this.setUpModal();
  }

  setUpModal() {
    const btn = document.getElementById(`newsletter-button-modal-${this.data.metaobjectId}`);
    const modal = document.getElementById(`newsletter-modal-${this.data.metaobjectId}`);
    const closeBtn = document.getElementById(`newsletter-modal-close-${this.data.metaobjectId}`);

    if (btn && modal) {
      btn.addEventListener('click', () => {
        modal.classList.add('active');
      });

      closeBtn?.addEventListener('click', () => {
        modal.classList.remove('active');
      });

      window.addEventListener('click', (event) => {
        if (event.target === modal) {
          modal.classList.remove('active');
        }
      });
    }
  }

  _setupHeaderElements() {}

  _injectEmailForm() {
    this.root.innerHTML = /* HTML */ `
      <div class="flex flex-col max-w-[90vw] lg:max-w-[450px] p-5 bg-[#f6f6f6]">
        ${this.data.first.title
          ? `<div class="!text-3xl metafield_reset text-center mb-3">${this.data.first.title}</div>`
          : ''}
        <div class="max-w-full">
          <img class="object-cover" src="${this.data.first.image}" />
        </div>
        <form class="klaviyo-email-form flex flex-col gap-2 w-fit my-2">
          <div class="flex flex-col w-full gap-2">
            <input
              type="text"
              name="email"
              placeholder="Twój e-mail"
              class="text-xs w-full h-[40px] px-4 py-2 border border-gray20 rounded-sm shadow-sm focus:ring focus:ring-pink-100 focus:border-pink-400 transition"
            />
            <button
              type="submit"
              class="btn btn--primary-2 border border-solid px-5 rounded-sm font-semibold py-2 transition uppercase font-sans text-xs shrink-0 tracking-[2px]"
            >
              ${this.buttonLabel}
            </button>
          </div>

          <p class="klaviyo-email-msg text-sm max-w-[500px]"></p>

          ${this.data.first.description
            ? `<div class="text-sm metafield_reset mb-2">${this.data.first.description}</div>`
            : ''}

          <label class="text-sm flex gap-2 items-baseline text-black cursor-pointer">
            <input
              type="checkbox"
              name="consent"
              class="font-sans text-xs font-medium leading-[1.45] tracking-[0.26px]"
            />
            <span class="max-w-[600px]">
              Chcę zapisać się do Newslettera (informacje o promocjach, zniżkach, premierach, konkursach oraz artykułach
              z serwisu You KNOW)
            </span>
          </label>
          <p class="klaviyo-email-consent-msg text-sm max-w-[500px] text-red"></p>
        </form>
        <div class="flex w-full justify-center gap-1">
          <a class="text-xs underline" href="https://yourkaya.pl/policies/terms-of-service">Regulamin zakupów</a>
          <span class="text-xs">i</span>
          <a class="text-xs underline" href="https://yourkaya.pl/policies/privacy-policy">Polityka prywatności</a>
        </div>
      </div>
    `;
  }

  _injectSmsForm() {
    this.root.innerHTML = /* HTML */ `
      <div class="flex flex-col max-w-[450px] p-5 bg-[#f6f6f6]">
        ${this.data.second.title
          ? `<div class="!text-3xl metafield_reset text-center mb-3">${this.data.second.title}</div>`
          : ''}
        <div class="max-w-full mb-2">
          <img class="object-cover" src="${this.data.second.image}" />
        </div>
        <form class="klaviyo-sms-form flex flex-col gap-2" novalidate>
          <div class="flex flex-col w-full gap-2 mt-2">
            <div class="flex w-full gap-2">
              <select name="prefix" class="border border-gray-300 rounded-sm border-gray20 py-2 text-xs">
                ${dialCodes
                  .map(
                    ({ code, flag }) =>
                      `<option value="${code}" ${code === '+48' ? 'selected' : ''}>${flag} ${code}</option>`
                  )
                  .join('')}
              </select>
              <input
                type="tel"
                name="phone"
                pattern="[0-9]{6,14}"
                placeholder="123 456 789"
                class="text-xs w-full h-[40px] px-4 py-2 border border-gray20 rounded-sm shadow-sm focus:ring focus:ring-pink-100 focus:border-pink-400 transition"
              />
            </div>
            <button
              type="submit"
              class="btn btn--primary-2 border border-solid px-5 rounded-sm font-semibold py-2 transition uppercase font-sans text-xs shrink-0 tracking-[2px]"
            >
              ${this.buttonLabel}
            </button>
          </div>

          <p class="klaviyo-sms-msg text-sm"></p>

          ${this.data.second.description
            ? `<div class="text-sm metafield_reset mb-2">${this.data.second.description}</div>`
            : ''}

          <label class="text-sm flex gap-2 items-baseline">
            <input
              type="checkbox"
              name="consent"
              class="font-sans text-xs font-medium leading-[1.45] tracking-[0.26px]"
            />
            <span class="text-xs max-w-[600px]">
              Chcę otrzymywać wiadomości SMS/MMS (informacje o promocjach, zniżkach, premierach i konkursach oraz
              artykułach z serwisu You KNOW)
            </span>
          </label>
          <p class="klaviyo-sms-consent-msg text-sm"></p>
        </form>

        <div class="flex w-full justify-center gap-1">
          <a class="text-xs underline" href="https://yourkaya.pl/policies/terms-of-service">Regulamin zakupów</a>
          <span class="text-xs">i</span>
          <a class="text-xs underline" href="https://yourkaya.pl/policies/privacy-policy">Polityka prywatności</a>
        </div>
      </div>
    `;
  }

  _insertEmailHeader(step) {}

  _insertSmsHeader(step) {}

  renderThanks() {
    this.root.innerHTML = ` 
      <div class="flex items-center flex-col gap-2 max-w-[90vw] lg:max-w-[450px] w-full p-5 bg-[#f6f6f6] text-center rounded-t-md text-[22px] font-normal">
        ${this.data.final.title ? `<div class="!text-3xl metafield_reset text-center mb-3">${this.data.final.title}</div>` : ''}
        ${this.data.final.description}
        <button class="back-to-shop mt-5 btn btn--primary-2 w-fit border border-solid px-5 rounded-sm font-semibold py-2 transition uppercase font-sans text-xs shrink-0 tracking-[2px]">Wróć do sklepu</button>
      </div>
    `;
    const btn = this.root.querySelector('.back-to-shop');
    const modal = document.getElementById(`newsletter-modal-${this.data.metaobjectId}`);
    if (btn) {
      btn.addEventListener('click', () => {
        if (modal) modal.classList.remove('active');
      });
    }
  }
}
customElements.define('klaviyo-mo-form', KlaviyoMetaobjectForm);
